import clsx from 'clsx';
import styles from './MultipleChoicesQuestion.module.scss';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { TextButton, ResultBox } from '~/components';
import { v4 as uuidv4 } from 'uuid';
import {
    getTypeOfResult,
    handleVibrate,
    // shuffleArray,
} from '~/utils/common';
import { OptionBox } from '~/components';
import { useTranslation } from 'react-i18next';

// Hàm tạo mảng với n phần tử
function createArray(options, shuffle) {
    // console.log('shuffle', shuffle);
    let array = [];
    options.forEach((item) => {
        array.push({
            id: uuidv4(),
            status: 'normal',
            text: item.option.join(' - '),
            option: item,
            animationRight: false,
        });
    });
    if (!shuffle)
        return array;
    else
        return array; // return shuffleArray(array);
}

function MultipleChoicesQuestion(
    {
        question,
        audioMap,
        notiCompleteAnAnswer,
        updateResult,
        className,
        handlePlay,
        handleStop,
        ...rest
    },
    ref,
) {
    const { t } = useTranslation();
    const [result, setResult] = useState('wrong'); // no_check || right || wrong
    const [isShowResult, setIsShowResult] = useState(false);
    const [optionsBox, setOptionsBox] = useState([]);
    const [multi, setMulti] = useState(false);

    function findResult() {
        let kq = true;
        // console.log('optionsBox', optionsBox);
        for (let i = 0; i < optionsBox.length; i++) {
            // console.log('optionsBox[i].status', optionsBox[i].status);
            // console.log(
            //     'optionsBox[i].option.answer',
            //     optionsBox[i].option.answer,
            // );
            if (
                (optionsBox[i].status === 'choosen' &&
                    !optionsBox[i].option.answer) ||
                (optionsBox[i].status !== 'choosen' &&
                    optionsBox[i].option.answer)
            ) {
                kq = false;
                break;
            }
        }
        return { count: 1, correct: kq ? 1 : 0 };
    }

    const handleOnClickCheck = () => {
        const kqTam = findResult();
        const type = getTypeOfResult(kqTam);
        setResult(type);
        notiCompleteAnAnswer(type, { count: 1, correct: type === 'right' ? 1 : 0 }, true);
        handleVibrate('strong');
        setIsShowResult(true);
    };

    const handleOnClickContinue = () => {
        updateResult({ count: 1, correct: result === 'right' ? 1 : 0 }, true);
    };

    const handleOnClickBox = (clickBox) => {
        // console.log('handleOnClickBox');
        if (isShowResult) return;
        if (question.type === 'multiple-choices-listening') {
            if (handlePlay)
                handlePlay(clickBox.text);
        }
        setOptionsBox((pre) => {
            return pre.map((eleBox) => {
                if (clickBox.id === eleBox.id) {
                    if (eleBox.status === 'normal') {
                        return { ...eleBox, status: 'choosen' };
                    } else {
                        return { ...eleBox, status: 'normal' };
                    }
                } else {
                    if (multi) return eleBox;
                    else return { ...eleBox, status: 'normal' };
                }
            });
        });
    };
    // Mỗi lần hiện result
    const hiddenInputRef = useRef(null);
    const resultDivRef = useRef(null);

    useEffect(() => {
        if (isShowResult) {
            // focus vào input ẩn để bắt sự kiện phím
            if (hiddenInputRef.current) {
                hiddenInputRef.current.focus();
            }
            // scroll đến div result
            if (resultDivRef.current) {
                resultDivRef.current.scrollIntoView();
            }
        }
    }, [isShowResult]);

    useEffect(() => {
        if (isShowResult && result) {
            setOptionsBox((pre) => {
                return pre.map((tempBox) => {
                    if (tempBox.status === 'choosen') {
                        return {
                            ...tempBox,
                            status: tempBox.option.answer ? 'right' : 'error',
                            choosen: true,
                        };
                    } else {
                        if (tempBox.option.answer)
                            return {
                                ...tempBox,
                                status: 'right',
                            };
                        else return tempBox;
                    }
                });
            });
        }
    }, [isShowResult, result]);

    // Mỗi khi question thay đổi, khởi tạo inputValues với số lượng input tương ứng
    useEffect(() => {
        setOptionsBox(createArray(question.options, question.shuffle));
        setIsShowResult(false);
        setMulti(
            question.options.filter((ele) => ele.answer === true).length > 1,
        );
    }, [question]);

    const renderContent = (text) => {
        const parts = text.split(/(___)/g);
        // let count = 0;
        return (
            <div>
                {parts.map((part, index) => {
                    if (part === '___') {
                        let temp = '\u00A0\u00A0\u00A0';
                        // if (choosenOption && choosenOption[count])
                        //     temp = choosenOption[count];
                        // count++;
                        return (
                            <span key={index} className={clsx(styles.blank)}>
                                {temp}
                            </span>
                        );
                    } else {
                        return <span key={index}>{part}</span>;
                    }
                })}
            </div>
        );
    };

    useEffect(() => {
        return () => {
            if (handleStop)
                handleStop();
        };
        // eslint-disable-next-line
    }, [])

    return (
        <div {...rest} className={clsx(styles.question, className)}>
            <div className={clsx(styles.images)}>
                {question.images && question.images.length > 0 &&
                    <img
                        key={question.images[0]}
                        src={question.images[0]}
                        alt={question.images[0]}
                        onError={(e) => {
                            e.target.onerror = null;
                            if (question.images.length > 1)
                                e.target.src = question.images[1];
                        }}
                    />
                }
            </div>
            <div className={clsx(styles.content)}>
                <div className={clsx(styles.ask)}>
                    {renderContent(question.content)}
                </div>
                {multi && (
                    <div className={clsx(styles.note)}>
                        Câu hỏi có 1 hoặc nhiều lựa chọn đúng
                    </div>
                )}
                <div className={clsx(styles.options)}>
                    {optionsBox.map((box) => {
                        return (
                            <OptionBox
                                questionType={question.type}
                                multi={multi}
                                key={box.id}
                                box={box}
                                onClick={() => handleOnClickBox(box)}
                            />
                        );
                    })}
                </div>
            </div>
            {/* action */}
            {!isShowResult && (
                <div className={styles.action}>
                    <TextButton
                        disable={
                            optionsBox.filter((box) => box.status === 'choosen')
                                .length === 0
                        }
                        normal
                        onClick={handleOnClickCheck}
                    >
                        {t('check')}
                    </TextButton>
                </div>
            )}
            {/* result */}
            {isShowResult && (
                <ResultBox
                    hideAnswer={true}
                    question={question}
                    result={result}
                    handleOnClickContinue={handleOnClickContinue}
                />
            )}
        </div>
    );
}
export default forwardRef(MultipleChoicesQuestion);
